<template>
  <div class="map-pc">
    <div class="amap-wrapper" style="width:100%; height: 40vh">
      <el-amap
        ref="map"
        :amap-manager="amapManager"
        :center="center"
        :zoom="zoom"
        :events="events"
        :plugin="plugin"
        class="amap-box"
      ></el-amap>
    </div>
    <div class="btn-area">
      <van-cell @click="show=true" title="地图队伍筛选" is-link :value="current" />
    </div>
    <div class="arrive_list">
      <div class="head">
        <img src="../../assets/arrive-head.png" />
      </div>
      <div class="body">
        <div
          v-for="(group, index) in show_list"
          :key="index"
          class="item"
          :class="`${(index%2==0)?'even':''}`"
        >
          <div class="info">
            <div class="g-name">{{group.groupname}}</div>
            <div class="g-num">{{group.ename}}</div>
          </div>
          <div class="l-time">{{group.l_time | time}}</div>
        </div>
      </div>
      <div class="footer">*以上信息仅供参考，以现场实际信息为准</div>
    </div>
    <van-popup position="bottom" v-model="show">
      <van-picker
        show-toolbar
        title="筛选队伍"
        :columns="t_list"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import map_icon from "../../assets/map-icon.png";
import { getMapData } from "@/libs/api.js";

import { AMapManager } from "vue-amap";
let amapManager = new AMapManager();
const line = [
  [121.212488, 31.056326],
  [121.212516, 31.057865],
  [121.212248, 31.057865],
  [121.212237, 31.058139],
  [121.214079, 31.058139],
  [121.214088, 31.057292],
  [121.218532, 31.057308],
  [121.218556, 31.058556],
  [121.218573, 31.05924],
  [121.217056, 31.059239],
  [121.216657, 31.059239],
  [121.215006, 31.059229],
  [121.214452, 31.059146],
  [121.213506, 31.058956],
  [121.211851, 31.058968],
  [121.211828, 31.057871],
  [121.211688, 31.057873],
  [121.211667, 31.056967],
  [121.21166, 31.05471],
  [121.2121, 31.054697],
  [121.212738, 31.054737],
  [121.213917, 31.054726],
  [121.214707, 31.05455],
  [121.215215, 31.054357],
  [121.215806, 31.054044],
  [121.216591, 31.053488],
  [121.216902, 31.053325],
  [121.217342, 31.053184],
  [121.2176, 31.053127],
  [121.218083, 31.053131],
  [121.218608, 31.053211],
  [121.218957, 31.053319],
  [121.21955, 31.053686],
  [121.21981, 31.053943],
  [121.219908, 31.054079],
  [121.218546, 31.054827],
  [121.218353, 31.054884],
  [121.217383, 31.054882],
  [121.217219, 31.05492],
  [121.21712, 31.054838],
  [121.217039, 31.054733],
  [121.216961, 31.054551],
  [121.216857, 31.054387],
  [121.21665, 31.054204],
  [121.216466, 31.054108],
  [121.215917, 31.053966],
  [121.215243, 31.054346],
  [121.214745, 31.054541],
  [121.213928, 31.054707],
  [121.212736, 31.054731],
  [121.212483, 31.054715],
  [121.212488, 31.056326]
];

const linex = {
  line1: [
    {
      left_line: [
        [121.212488, 31.056326],
        [121.212516, 31.057865],
        [121.212248, 31.057865],
        [121.212237, 31.058139],
        [121.214079, 31.058139],
        [121.214088, 31.057292],
        [121.218532, 31.057308],
        [121.218556, 31.058556]
      ],
      point: [121.212488, 31.056326],
      distance: 0
    },
    {
      left_line: [
        [121.212516, 31.057865],
        [121.212248, 31.057865],
        [121.212237, 31.058139],
        [121.214079, 31.058139],
        [121.214088, 31.057292],
        [121.218532, 31.057308],
        [121.218556, 31.058556]
      ],
      point: [121.212516, 31.057865],
      distance: 171.34
    },
    {
      left_line: [
        [121.212248, 31.057865],
        [121.212237, 31.058139],
        [121.214079, 31.058139],
        [121.214088, 31.057292],
        [121.218532, 31.057308],
        [121.218556, 31.058556]
      ],
      point: [121.212248, 31.057865],
      distance: 196.9
    },
    {
      left_line: [
        [121.212237, 31.058139],
        [121.214079, 31.058139],
        [121.214088, 31.057292],
        [121.218532, 31.057308],
        [121.218556, 31.058556]
      ],
      point: [121.212237, 31.058139],
      distance: 227.42
    },
    {
      left_line: [
        [121.214079, 31.058139],
        [121.214088, 31.057292],
        [121.218532, 31.057308],
        [121.218556, 31.058556]
      ],
      point: [121.214079, 31.058139],
      distance: 403.07
    },
    {
      left_line: [
        [121.214088, 31.057292],
        [121.218532, 31.057308],
        [121.218556, 31.058556]
      ],
      point: [121.214088, 31.057292],
      distance: 497.36
    },
    {
      left_line: [[121.218532, 31.057308], [121.218556, 31.058556]],
      point: [121.218532, 31.057308],
      distance: 921.16
    },
    {
      left_line: [[121.218556, 31.058556]],
      point: [121.218556, 31.058556],
      distance: 1060.1
    }
  ],
  line2: [
    {
      left_line: [
        [121.218556, 31.058556],
        [121.218573, 31.05924],
        [121.217056, 31.059239],
        [121.216657, 31.059239],
        [121.215006, 31.059229],
        [121.214452, 31.059146],
        [121.213506, 31.058956],
        [121.211851, 31.058968],
        [121.211828, 31.057871],
        [121.211688, 31.057873],
        [121.211667, 31.056967]
      ],
      point: [121.218556, 31.058556],
      distance: 0
    },
    {
      left_line: [
        [121.218573, 31.05924],
        [121.217056, 31.059239],
        [121.216657, 31.059239],
        [121.215006, 31.059229],
        [121.214452, 31.059146],
        [121.213506, 31.058956],
        [121.211851, 31.058968],
        [121.211828, 31.057871],
        [121.211688, 31.057873],
        [121.211667, 31.056967]
      ],
      point: [121.218573, 31.05924],
      distance: 76.16
    },
    {
      left_line: [
        [121.217056, 31.059239],
        [121.216657, 31.059239],
        [121.215006, 31.059229],
        [121.214452, 31.059146],
        [121.213506, 31.058956],
        [121.211851, 31.058968],
        [121.211828, 31.057871],
        [121.211688, 31.057873],
        [121.211667, 31.056967]
      ],
      point: [121.217056, 31.059239],
      distance: 220.82
    },
    {
      left_line: [
        [121.216657, 31.059239],
        [121.215006, 31.059229],
        [121.214452, 31.059146],
        [121.213506, 31.058956],
        [121.211851, 31.058968],
        [121.211828, 31.057871],
        [121.211688, 31.057873],
        [121.211667, 31.056967]
      ],
      point: [121.216657, 31.059239],
      distance: 258.87
    },
    {
      left_line: [
        [121.215006, 31.059229],
        [121.214452, 31.059146],
        [121.213506, 31.058956],
        [121.211851, 31.058968],
        [121.211828, 31.057871],
        [121.211688, 31.057873],
        [121.211667, 31.056967]
      ],
      point: [121.215006, 31.059229],
      distance: 416.31
    },
    {
      left_line: [
        [121.214452, 31.059146],
        [121.213506, 31.058956],
        [121.211851, 31.058968],
        [121.211828, 31.057871],
        [121.211688, 31.057873],
        [121.211667, 31.056967]
      ],
      point: [121.214452, 31.059146],
      distance: 469.94
    },
    {
      left_line: [
        [121.213506, 31.058956],
        [121.211851, 31.058968],
        [121.211828, 31.057871],
        [121.211688, 31.057873],
        [121.211667, 31.056967]
      ],
      point: [121.213506, 31.058956],
      distance: 562.6
    },
    {
      left_line: [
        [121.211851, 31.058968],
        [121.211828, 31.057871],
        [121.211688, 31.057873],
        [121.211667, 31.056967]
      ],
      point: [121.211851, 31.058968],
      distance: 720.43
    },
    {
      left_line: [
        [121.211828, 31.057871],
        [121.211688, 31.057873],
        [121.211667, 31.056967]
      ],
      point: [121.211828, 31.057871],
      distance: 842.57
    },
    {
      left_line: [[121.211688, 31.057873], [121.211667, 31.056967]],
      point: [121.211688, 31.057873],
      distance: 855.92
    },
    {
      left_line: [[121.211667, 31.056967]],
      point: [121.211667, 31.056967],
      distance: 956.79
    }
  ],
  line3: [
    {
      left_line: [
        [121.211667, 31.056967],
        [121.21166, 31.05471],
        [121.2121, 31.054697],
        [121.212738, 31.054737],
        [121.213917, 31.054726],
        [121.214707, 31.05455],
        [121.215215, 31.054357],
        [121.215806, 31.054044],
        [121.216591, 31.053488],
        [121.216902, 31.053325],
        [121.217342, 31.053184],
        [121.2176, 31.053127],
        [121.218083, 31.053131],
        [121.218608, 31.053211],
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.211667, 31.056967],
      distance: 0
    },
    {
      left_line: [
        [121.21166, 31.05471],
        [121.2121, 31.054697],
        [121.212738, 31.054737],
        [121.213917, 31.054726],
        [121.214707, 31.05455],
        [121.215215, 31.054357],
        [121.215806, 31.054044],
        [121.216591, 31.053488],
        [121.216902, 31.053325],
        [121.217342, 31.053184],
        [121.2176, 31.053127],
        [121.218083, 31.053131],
        [121.218608, 31.053211],
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.21166, 31.05471],
      distance: 251.25
    },
    {
      left_line: [
        [121.2121, 31.054697],
        [121.212738, 31.054737],
        [121.213917, 31.054726],
        [121.214707, 31.05455],
        [121.215215, 31.054357],
        [121.215806, 31.054044],
        [121.216591, 31.053488],
        [121.216902, 31.053325],
        [121.217342, 31.053184],
        [121.2176, 31.053127],
        [121.218083, 31.053131],
        [121.218608, 31.053211],
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.2121, 31.054697],
      distance: 293.23
    },
    {
      left_line: [
        [121.212738, 31.054737],
        [121.213917, 31.054726],
        [121.214707, 31.05455],
        [121.215215, 31.054357],
        [121.215806, 31.054044],
        [121.216591, 31.053488],
        [121.216902, 31.053325],
        [121.217342, 31.053184],
        [121.2176, 31.053127],
        [121.218083, 31.053131],
        [121.218608, 31.053211],
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.212738, 31.054737],
      distance: 354.24
    },
    {
      left_line: [
        [121.213917, 31.054726],
        [121.214707, 31.05455],
        [121.215215, 31.054357],
        [121.215806, 31.054044],
        [121.216591, 31.053488],
        [121.216902, 31.053325],
        [121.217342, 31.053184],
        [121.2176, 31.053127],
        [121.218083, 31.053131],
        [121.218608, 31.053211],
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.213917, 31.054726],
      distance: 466.68
    },
    {
      left_line: [
        [121.214707, 31.05455],
        [121.215215, 31.054357],
        [121.215806, 31.054044],
        [121.216591, 31.053488],
        [121.216902, 31.053325],
        [121.217342, 31.053184],
        [121.2176, 31.053127],
        [121.218083, 31.053131],
        [121.218608, 31.053211],
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.214707, 31.05455],
      distance: 544.53
    },
    {
      left_line: [
        [121.215215, 31.054357],
        [121.215806, 31.054044],
        [121.216591, 31.053488],
        [121.216902, 31.053325],
        [121.217342, 31.053184],
        [121.2176, 31.053127],
        [121.218083, 31.053131],
        [121.218608, 31.053211],
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.215215, 31.054357],
      distance: 597.52
    },
    {
      left_line: [
        [121.215806, 31.054044],
        [121.216591, 31.053488],
        [121.216902, 31.053325],
        [121.217342, 31.053184],
        [121.2176, 31.053127],
        [121.218083, 31.053131],
        [121.218608, 31.053211],
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.215806, 31.054044],
      distance: 663.78
    },
    {
      left_line: [
        [121.216591, 31.053488],
        [121.216902, 31.053325],
        [121.217342, 31.053184],
        [121.2176, 31.053127],
        [121.218083, 31.053131],
        [121.218608, 31.053211],
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.216591, 31.053488],
      distance: 760.92
    },
    {
      left_line: [
        [121.216902, 31.053325],
        [121.217342, 31.053184],
        [121.2176, 31.053127],
        [121.218083, 31.053131],
        [121.218608, 31.053211],
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.216902, 31.053325],
      distance: 795.69
    },
    {
      left_line: [
        [121.217342, 31.053184],
        [121.2176, 31.053127],
        [121.218083, 31.053131],
        [121.218608, 31.053211],
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.217342, 31.053184],
      distance: 840.49
    },
    {
      left_line: [
        [121.2176, 31.053127],
        [121.218083, 31.053131],
        [121.218608, 31.053211],
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.2176, 31.053127],
      distance: 865.9
    },
    {
      left_line: [
        [121.218083, 31.053131],
        [121.218608, 31.053211],
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.218083, 31.053131],
      distance: 911.96
    },
    {
      left_line: [
        [121.218608, 31.053211],
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.218608, 31.053211],
      distance: 962.81
    },
    {
      left_line: [
        [121.218957, 31.053319],
        [121.21955, 31.053686],
        [121.21981, 31.053943]
      ],
      point: [121.218957, 31.053319],
      distance: 998.2
    },
    {
      left_line: [[121.21955, 31.053686], [121.21981, 31.053943]],
      point: [121.21955, 31.053686],
      distance: 1067.97
    },
    {
      left_line: [[121.21981, 31.053943]],
      point: [121.21981, 31.053943],
      distance: 1105.82
    }
  ],
  line4: [
    {
      left_line: [
        [121.21981, 31.053943],
        [121.219908, 31.054079],
        [121.218546, 31.054827],
        [121.218353, 31.054884],
        [121.217383, 31.054882],
        [121.217219, 31.05492],
        [121.21712, 31.054838],
        [121.217039, 31.054733],
        [121.216961, 31.054551],
        [121.216857, 31.054387],
        [121.21665, 31.054204],
        [121.216466, 31.054108],
        [121.215917, 31.053966],
        [121.215243, 31.054346],
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.21981, 31.053943],
      distance: 0
    },
    {
      left_line: [
        [121.219908, 31.054079],
        [121.218546, 31.054827],
        [121.218353, 31.054884],
        [121.217383, 31.054882],
        [121.217219, 31.05492],
        [121.21712, 31.054838],
        [121.217039, 31.054733],
        [121.216961, 31.054551],
        [121.216857, 31.054387],
        [121.21665, 31.054204],
        [121.216466, 31.054108],
        [121.215917, 31.053966],
        [121.215243, 31.054346],
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.219908, 31.054079],
      distance: 17.79
    },
    {
      left_line: [
        [121.218546, 31.054827],
        [121.218353, 31.054884],
        [121.217383, 31.054882],
        [121.217219, 31.05492],
        [121.21712, 31.054838],
        [121.217039, 31.054733],
        [121.216961, 31.054551],
        [121.216857, 31.054387],
        [121.21665, 31.054204],
        [121.216466, 31.054108],
        [121.215917, 31.053966],
        [121.215243, 31.054346],
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.218546, 31.054827],
      distance: 172.08
    },
    {
      left_line: [
        [121.218353, 31.054884],
        [121.217383, 31.054882],
        [121.217219, 31.05492],
        [121.21712, 31.054838],
        [121.217039, 31.054733],
        [121.216961, 31.054551],
        [121.216857, 31.054387],
        [121.21665, 31.054204],
        [121.216466, 31.054108],
        [121.215917, 31.053966],
        [121.215243, 31.054346],
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.218353, 31.054884],
      distance: 191.55
    },
    {
      left_line: [
        [121.217383, 31.054882],
        [121.217219, 31.05492],
        [121.21712, 31.054838],
        [121.217039, 31.054733],
        [121.216961, 31.054551],
        [121.216857, 31.054387],
        [121.21665, 31.054204],
        [121.216466, 31.054108],
        [121.215917, 31.053966],
        [121.215243, 31.054346],
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.217383, 31.054882],
      distance: 284.05
    },
    {
      left_line: [
        [121.217219, 31.05492],
        [121.21712, 31.054838],
        [121.217039, 31.054733],
        [121.216961, 31.054551],
        [121.216857, 31.054387],
        [121.21665, 31.054204],
        [121.216466, 31.054108],
        [121.215917, 31.053966],
        [121.215243, 31.054346],
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.217219, 31.05492],
      distance: 300.25
    },
    {
      left_line: [
        [121.21712, 31.054838],
        [121.217039, 31.054733],
        [121.216961, 31.054551],
        [121.216857, 31.054387],
        [121.21665, 31.054204],
        [121.216466, 31.054108],
        [121.215917, 31.053966],
        [121.215243, 31.054346],
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.21712, 31.054838],
      distance: 313.38
    },
    {
      left_line: [
        [121.217039, 31.054733],
        [121.216961, 31.054551],
        [121.216857, 31.054387],
        [121.21665, 31.054204],
        [121.216466, 31.054108],
        [121.215917, 31.053966],
        [121.215243, 31.054346],
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.217039, 31.054733],
      distance: 327.39
    },
    {
      left_line: [
        [121.216961, 31.054551],
        [121.216857, 31.054387],
        [121.21665, 31.054204],
        [121.216466, 31.054108],
        [121.215917, 31.053966],
        [121.215243, 31.054346],
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.216961, 31.054551],
      distance: 348.98
    },
    {
      left_line: [
        [121.216857, 31.054387],
        [121.21665, 31.054204],
        [121.216466, 31.054108],
        [121.215917, 31.053966],
        [121.215243, 31.054346],
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.216857, 31.054387],
      distance: 369.75
    },
    {
      left_line: [
        [121.21665, 31.054204],
        [121.216466, 31.054108],
        [121.215917, 31.053966],
        [121.215243, 31.054346],
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.21665, 31.054204],
      distance: 398.12
    },
    {
      left_line: [
        [121.216466, 31.054108],
        [121.215917, 31.053966],
        [121.215243, 31.054346],
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.216466, 31.054108],
      distance: 418.66
    },
    {
      left_line: [
        [121.215917, 31.053966],
        [121.215243, 31.054346],
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.215917, 31.053966],
      distance: 473.35
    },
    {
      left_line: [
        [121.215243, 31.054346],
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.215243, 31.054346],
      distance: 550.3
    },
    {
      left_line: [
        [121.214745, 31.054541],
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.214745, 31.054541],
      distance: 602.52
    },
    {
      left_line: [
        [121.213928, 31.054707],
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.213928, 31.054707],
      distance: 682.59
    },
    {
      left_line: [
        [121.212736, 31.054731],
        [121.212483, 31.054715],
        [121.212488, 31.056326]
      ],
      point: [121.212736, 31.054731],
      distance: 796.3
    },
    {
      left_line: [[121.212483, 31.054715], [121.212488, 31.056326]],
      point: [121.212483, 31.054715],
      distance: 820.49
    },
    {
      left_line: [[121.212488, 31.056326]],
      point: [121.212488, 31.056326],
      distance: 999.83
    }
  ]
};


export default {
  filters: {
    time(val) {
      if (!val) return "--分--秒";
      val = new Date(val);
      let h = val.getHours();
      let m = val.getMinutes();
      if (isNaN(h) || isNaN(m)) {
        return "--分--秒";
      }
      return h + "时" + m + "分";
    }
  },
  mounted() {
    let self = this;
  },
  data() {
    let self = this;
    return {
      show: false,
      current: "全部",
      first: false,
      show_list: [],
      l_time_list: [],
      t_list: ["全部"],
      p_list: [],
      list: [],
      amapManager,
      center: [121.213164, 31.055582],
      zoom: 12,
      events: {
        init: o => {
          self.amapManager = o;
          var polyline = new AMap.Polyline({
            map: o,
            path: line,
            showDir: true,
            strokeColor: "#28F", //线颜色
            // strokeOpacity: 1,     //线透明度
            strokeWeight: 6 //线宽
            // strokeStyle: "solid"  //线样式
          });

          o.setFitView();
          o.setMapStyle("amap://styles/db0aae9736c55cc8d4379cedce535e0b");

          self.get_map_data();
          setInterval(() => {
            self.get_map_data();
          }, 5000);
        },
        // 地图点击事件
        click: e => {}
      },
      plugin: []
    };
  },
  methods: {
    onCancel() {
      this.show = false;
    },
    onConfirm(e) {
      Object.keys(this.p_list).forEach(key => {
        if (e == "全部") {
          this.p_list[key].marker.show();
        } else {
          if (key == "A" + e || key == "B" + e) {
            this.p_list[key].marker.show();
          } else {
            this.p_list[key].marker.hide();
          }
        }
      });
      this.current = e;
      this.show = false;
    },
    get_map_data() {
      getMapData(this.$route.query)
        .then(r => {
          let self = this;
          this.l_time_list = [];
          if (r.status == 200) {
            this.list = r.data.list;
            let p_list = {};
            r.data.list.forEach((row, index) => {
              if (
                !(row.cpname == "cp0" && (row.chipid2 || row.statenumber == 1))
              ) {
                let l_time;
                switch (row.cpname) {
                  case "cp0":
                    l_time = 4 / row.speed;
                    break;
                  case "cp1":
                    l_time = 3 / row.speed;
                    break;
                  case "cp2":
                    l_time = 2 / row.speed;
                    break;
                  case "cp3":
                    l_time = 1 / row.speed;
                    break;
                }

                l_time = l_time * 3600000 + row.time * 1;

                this.l_time_list.push({
                  ename: row.ename,
                  groupname: row.groupname,
                  unit: row.unit,
                  l_time
                });
              }

              let i = row.cpname.slice(-1) * 1 + 1;

              if (!this.first) {
                let team = this.t_list.find(item => {
                  return item == row.scorename.slice(1);
                });
                if (!team) {
                  this.t_list.push(row.scorename.slice(1));
                }
              }
              // 判断是否完赛
              if (row.speed == 0) {
                console.log("完赛");
                let marker;
                if (this.p_list[row.scorename]) {
                  marker = this.p_list[row.scorename].marker;
                  marker.stopMove();
                  marker.setPosition([121.212488, 31.056326]);
                } else {
                  marker = new AMap.Marker({
                    map: self.amapManager,
                    position: [121.212488, 31.056326],
                    // icon: map_icon,
                    // offset: new AMap.Pixel(-13, -13),
                    autoRotation: true,
                    angle: -90,
                    label: {
                      content: row.scorename,
                      offset: new AMap.Pixel(-8, -24),
                      direction: "center"
                    }
                  });
                }
                // ...
              } else {
                if (this.p_list[row.scorename]) {
                  // 本地存在这个队伍的数据
                  if (this.p_list[row.scorename].cpname != row.cpname) {
                    // 经过下一个cp点
                    console.log("经过下一个cp点");
                    let marker = this.p_list[row.scorename].marker;
                    // 停止动画
                    marker.stopMove();
                    // 开始下一段路线动画

                    new AMap.Polyline({
                      path: linex["line" + i][0].left_line,
                      showDir: true,
                      strokeColor: "#28F", //线颜色
                      // strokeOpacity: 1,     //线透明度
                      strokeWeight: 6 //线宽
                      // strokeStyle: "solid"  //线样式
                    });

                    let l = [...linex["line" + i][0].left_line].concat();

                    marker.moveAlong(l, row.speed);
                    // 配置cpname
                    this.p_list[row.scorename].cpname = row.cpname;
                  } else {
                    // 数据无变化
                    console.log("数据无变化");
                  }
                  p_list = this.p_list;
                } else {
                  p_list[row.scorename] = {};

                  // 第一次经过cp1, 画点
                  console.log("第一次取到数据, 画点" + row.scorename);
                  p_list[row.scorename].cpname = row.cpname;
                  let p_line = self.set_line({
                    speed: row.speed,
                    time: row.time,
                    systime: r.data.systime,
                    cpname: row.cpname
                  });
                  let marker = null;

                  if (p_line.length > 1) {
                    marker = new AMap.Marker({
                      map: self.amapManager,
                      position: [121.212488, 31.056326],
                      // icon: map_icon,
                      // offset: new AMap.Pixel(-13, -13),
                      autoRotation: true,
                      angle: -90,
                      label: {
                        content: row.scorename,
                        offset: new AMap.Pixel(-8, -24),
                        direction: "center"
                      }
                    });

                    let l = [...p_line].concat();

                    marker.moveAlong(l, row.speed);
                  } else if (p_line.length == 1) {
                    if (i == 4) {
                      i = 0;
                    }
                    marker = new AMap.Marker({
                      map: self.amapManager,
                      position: linex["line" + (i + 1)][0].point,
                      // icon: map_icon,
                      // offset: new AMap.Pixel(-13, -13),
                      autoRotation: true,
                      angle: -90,
                      label: {
                        content: row.scorename,
                        offset: new AMap.Pixel(-8, -24),
                        direction: "center"
                      }
                    });
                  }

                  p_list[row.scorename].marker = marker;
                }
              }
            });
            console.log("--------");

            this.l_time_list.sort((a, b) => {
              return a.l_time - b.l_time;
            });

            this.show_list = this.l_time_list.slice(0, 10);

            self.$nextTick(() => {
              self.p_list = p_list;
              if (!self.first) {
                self.t_list.sort((a, b) => {
                  return a * 1 - b * 1;
                });
                self.first = true;
              }
            });
          } else {
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    set_line(params) {
      let time = params.systime * 1000 - params.time;
      let dis = params.speed * (time / 3600);

      let item_line = linex["line" + (params.cpname.slice(-1) * 1 + 1)];

      return this.get_index(item_line, dis);
    },
    get_index(arr, dis) {
      let index;
      let self = this;
      let item = arr.find((item, index) => {
        return dis <= item.distance;
      });

      if (item) {
        new AMap.Polyline({
          path: item.left_line,
          showDir: true,
          strokeColor: "#28F", //线颜色
          // strokeOpacity: 1,     //线透明度
          strokeWeight: 6 //线宽
          // strokeStyle: "solid"  //线样式
        });
        return item.left_line;
      } else {
        return arr[arr.length - 1].left_line;
      }
    },
    startAnimation(line, speed) {
      marker.moveAlong(
        line,
        speed || 20,
        e => {
          // console.log(e);
          return e;
        },
        false
      );
    },
    pauseAnimation() {
      marker.pauseMove();
    },
    resumeAnimation() {
      marker.resumeMove();
    },
    stopAnimation() {
      marker.stopMove();
    }
  }
};
</script>


<style lang="less" scoped>
.map-pc {
  .arrive_list {
    border-top: 1px solid #eee;
    min-height: 60vh;
    background-color: #c5141e;
    position: relative;
    padding-bottom: 100px;
    .head {
      margin-bottom: 30px;
      img {
        width: 100%;
      }
    }
    .body {
      .item {
        padding: 10px 20px 10px 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &.even {
          background: #b1111a;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
        }
        .info {
          color: #fff;
          font-size: 20px;
          .g-name {
            font-weight: bold;
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .l-time {
          font-size: 20px;
          color: #fff;
        }
      }
    }
    .footer {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 10px 0;
      text-align: center;
      background: #fff;
      color: #a31119;
      font-size: 12px;
    }
  }
}
</style>